import { render, staticRenderFns } from "./SourceSettings.vue?vue&type=template&id=006a40e8&"
import script from "./SourceSettings.vue?vue&type=script&lang=ts&"
export * from "./SourceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports